export const templateCards = [
  {
    id: 'sender-booking',
    title: 'Sender Message (Booking)', translationKey: 'smsSenderBooking',
    isStandard: true,
    message:
      'Dear [SN], Your luggage booking is received for LR No [LR], From [VN] to [DM] - Thanks [OPNAME] - MANTIS #1107160812034250718',
  },
  {
    id: 'receiver-booking',
    title: 'Receiver Message (Booking)', translationKey: 'smsReceiverBooking',
    isStandard: false,
    message:
      'Greetings from [ON], Please contact Our Branch [CBN] on [BP] or visit at [BA]. Click here to get location [LU]. Thank You. - MANTIS #1107160812034250718',
  },
  {
    id: 'sender-dispatch',
    title: 'Sender Message (Dispatch)', translationKey: 'smsSenderDispatch',
    isStandard: true,
    message:
      '[SN]:Your luggage with LR. No: [CVN] has been dispatched to [MVN] on today - [CDM] - MANTIS ##1107160812034250718',
  },
  {
    id: 'receiver-dispatch',
    title: 'Receiver Message (Dispatch)', translationKey: 'smsReceiverDispatch',
    isStandard: false,
    message:
      '[RN]:Your luggage with LR. No: [CVN] has been dispatched to [MVN] on today - [CDM] - MANTIS ##1107160812034250718',
  },
  {
    id: 'sender-delivery',
    title: 'Sender Message (Delivery)', translationKey: 'smsSenderDelivery',
    isStandard: true,
    message:
      'Dear [SN], Luggage No [LR], collected by [RN], from [DN] branch - For future booking contact on [TCN] - [OPNAME] - MANTIS ##1107160812034250718',
  },
  {
    id: 'receiver-delivery',
    title: 'Receiver Message (Delivery)', translationKey: 'smsReceiverDelivery',
    isStandard: false,
    message:
      'Dear [RN], Luggage No [LR], sent by [SN] from [BN] is delivered to you - For future booking contact on [TCN] - [OPNAME] - MAVEN ##1507164648264463705',
  },
  {
    id: 'receiver-notreceived',
    title: 'Receiver Message (Not Received)', translationKey: 'smsReceiverNotReceived',
    isStandard: false,
    message:
      'Dear [RN], your luggage with LR No [LR] has been received at [DN]. Please pickup before [DD] to avoid demmurge charges. - [OPNAME] - MANTIS ##1107160812057624036',
    config: [{ label: 'Hrs', translationKey: 'smsHrs', value: '24' }],
  },
  {
    id: 'sender-cancel',
    title: 'Sender Message (Cancelled)', translationKey: 'smsSenderCancelled',
    isStandard: true,
    message:
      'Dear [SN], Your luggage no [LR] is cancelled on your request. For future booking contact on [TCN] - [OPNAME] - MANTIS ##1107160812090385115',
  },
  {
    id: 'receiver-cancel',
    title: 'Receiver Message (Cancelled)', translationKey: 'smsReceiverCancelled',
    isStandard: false,
    message: 'Dear [RN], Your luggage no [LR] is cancelled. For future booking contact on [TCN] - [OPNAME] - MANTIS ##1107160812098171960',
  },
  {
    id: 'inquiry-customer',
    title: 'Inquiry Message (Customer)', translationKey: 'smsInquiryCustomer',
    isStandard: true,
    message:
      'Dear [CN], Luggage booking request is received. We will contact you soon - [OPNAME] - MANTIS ##1107160812131956681',
    config: [{ label: 'Mobile Nos', translationKey: 'smsMobileNos', value: '8999818776' }],
  },
  {
    id: 'inquiry-operator',
    title: 'Inquiry Message (Operator)', translationKey: 'smsInquiryOperator',
    isStandard: true,
    message:
      'A luggage inquiry from customer [CN], Mob no is [CM], From [FC] to [TC], for [BT] - [OPNAME] - MANTIS ##1107160812140237658',
  },
  {
    id: 'receiver-reminder',
    title: 'Receiver Message (Demurrage Reminder)', translationKey: 'smsReceiverDemurrage',
    isStandard: true,
    message:
      'Dear [RN], Please collect your LR No [LR] immediatly to avoid demmurage charges. - [OPNAME] - MAVEN ##1507164648264463705',
    schedule: { once: true, days: '1' },
  },
]

export const tagColumns = [
  [
    ['LR', 'LR No'],
    ['SM', "Sender's Mobile"],
    ['BN', 'Bkg Branch Name'],
    ['IL', 'Insurance Link'],
    ['BT', 'Booking Type'],
    ['ON', 'Operator Name'],
    ['MVN', 'Master Vehicle Number'],
  ],
  [
    ['PT', 'Payment Type'],
    ['RM', "Receiver's Mobile"],
    ['DN', 'Destination Branch Name'],
    ['MLR', 'Manual LR No.'],
    ['LL', 'LR Link'],
    ['CBN', 'Company Branch Name'],
  ],
  [
    ['FC', 'From City'],
    ['IT', 'Item Count'],
    ['GV', 'Goods Value'],
    ['DBA', 'Destination Branch Add.'],
    ['ET', 'Event Type'],
    ['BA', 'Branch Address'],
  ],
  [
    ['TC', 'To City'],
    ['CH', 'Total Charge'],
    ['DD', 'Demmurge StartDateTime'],
    ['CN', 'Customer Name'],
    ['LBN', 'Login Branch'],
    ['LU', 'Location URL'],
  ],
  [
    ['SN', "Sender's Name"],
    ['BP', 'Branch Mobile'],
    ['RB', 'Received By'],
    ['CM', 'Customer Mob.'],
    ['LUN', 'Login User'],
    ['CVN', 'Vehicle No'],
  ],
  [
    ['RN', "Receiver's Name"],
    ['DP', 'Destination Branch Mob.'],
    ['TCN', 'To City Contact No.'],
    ['CE', 'Customer Email'],
    ['CON', 'Consignment'],
    ['CDM', 'Driver Number'],
  ],
]

export const cardSx = {
  border: '1px solid #d7dbe3',
  borderRadius: '12px',
  overflow: 'hidden',
  background: '#fff',
  display: 'flex',
  flexDirection: 'column',
}

export const cardHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: '#fff',
  padding: '8px 10px',
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: 1.2,
}

export const truncateText = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}